require("./bootstrap");
require("./global-components")
require("./event-bus");

import VueObserveVisibility from "vue-observe-visibility";
import pluralize from "pluralize";
import MQ from "vue-match-media";
import Vue from "vue";

Vue.filter("pluralize", pluralize);
Vue.use(VueObserveVisibility);
Vue.use(MQ);
